export const FORM_FIELD = {
  NAME: 'name',
  PROFILE: 'runProfileId',
  SCREEN_SIZE: 'screenSizeType',
};
